import { SYSTEM } from 'socket-resources/namespaces/index'

export const WALLET_USER_WALLET_BALANCE = '/wallet/userWalletBalance'
export const SYSTEM_GAME_SETTINGS_UPDATE = `${SYSTEM}/gameSettings`
